module.exports = __webpack_public_path__ + "static/media/img01.d7265326.png";